import {
  ImportLeadsData,
  ImportLeadsResponse,
  ImportStatusResponse
} from "./types";
import { useAPIMutation } from "@/services/api/hook";
import useAPI from "@/services/api/hook";
import { ExtendedUseQueryResult } from "@/services/api/types";

export const useImportLeadsMutation = () => {
  return useAPIMutation<
    {
      data: FormData;
      queryParams: Partial<ImportLeadsData>;
    },
    ImportLeadsResponse
  >("import/leads", {
    method: "POST"
  });
};

export const useImportLeadsStatus = (
  importId: string,
  options?: { enabled?: boolean }
): ExtendedUseQueryResult<ImportStatusResponse> => {
  return useAPI(
    "import/leadsStatus",
    {
      pathParams: { import_id: importId }
    },
    {
      enabled: options?.enabled ?? false,
      refetchInterval: (query) => {
        // Stop polling if status is completed or failed
        const data = query.state.data as ImportStatusResponse | undefined;
        if (data?.status === "completed" || data?.status === "failed") {
          return false;
        }
        // Poll every 30 seconds while processing
        return 30000;
      }
    }
  );
};
